import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=516391b2&scoped=true"
import script from "./Notification.ts?vue&type=script&lang=ts&external"
export * from "./Notification.ts?vue&type=script&lang=ts&external"
import style0 from "./Notification.vue?vue&type=style&index=0&id=516391b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516391b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516391b2')) {
      api.createRecord('516391b2', component.options)
    } else {
      api.reload('516391b2', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=516391b2&scoped=true", function () {
      api.rerender('516391b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/NetworkNotification/Notification/Notification.vue"
export default component.exports